import { useEffect, useRef, useState } from "react";

export default function SearchDropdown({
  label,
  placeholder,
  options,
  selected,
  onSelect,
  lang='en',
  getLabel,
  searchable = false,
  hideTitle = true,
}) {
  const [open, setOpen] = useState(false);
  const [search, setSearch] = useState("");
  const ref = useRef();
  const resolveLabel = (o) => {
    if (getLabel) return getLabel(o);
    if (typeof o.label === "object") return o.label[lang];
    return o.label;
  };

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (ref.current && !ref.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const filteredOptions = searchable
    ? options.filter((o) =>
        resolveLabel(o).toLowerCase().includes(search.toLowerCase()),
      )
    : options;

  return (
    <div className="lud-search-dropdown" ref={ref}>
      <div className="lud-search-inputs">
        {hideTitle&&<label>
          <strong>{label}</strong>
        </label>}

        {searchable ? (
  <input
    type="text"
    placeholder={placeholder}
    value={search || (selected ? resolveLabel(selected) : "")}
    onFocus={() => setOpen(true)}
    onChange={(e) => setSearch(e.target.value)}
    className="lud-search-input"
  />
) : (
  <div
    className="selected-lud-search-label"
    onClick={() => setOpen((prev) => !prev)}
  >
    {selected ? resolveLabel(selected) : placeholder}
  </div>
)}
      </div>

      {open && (
        <div className="lud-search-dropdown-menu">
          {filteredOptions.map((o, i) => (
            <label
              key={i}
              className="lud-search-option"
              onClick={() => {
                onSelect(o);
                setSearch("");
                setOpen(false);
              }}
              style={{ cursor: "pointer" }}
            >
              {resolveLabel(o)}
            </label>
          ))}
        </div>
      )}
    </div>
  );
}
